var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"id":"new-convo-button","block":"","pill":"","variant":"info"},on:{"click":function () { return _vm.open(); }}},[_vm._v(" New Conversation ")])}
var staticRenderFns = []

export { render, staticRenderFns }